import styled from 'styled-components'

export const MainHead = styled.div`
    width: 100%;
    overflow: auto;
    font-size: 60px;
    font-weight: 900;
    text-align: center;
    position: absolute;
    top: 20%;

    @media (max-width: 992px) {
        font-size: 40px;
        top: 20%;
    }

    @media (max-width: 576px) {
        top: 22%;
        font-size: 30px;
    }
    
`
export const Logo = styled.div`
    position: absolute;
    top: 10px;
    left: 10px;
    width: 180px;
    height: 180px;

    @media (max-width: 992px) {
        width: 140px;
        height: 140px;
    }

    @media (max-width: 576px) {
        width: 100px;
        height: 100px;
    }  
`

export const Demo = styled.div`
    display:  ${props => props.display||'block'};
    position: absolute;
    top: 55%;
    left: 0
    font-size: 16px;
    width: 90%;
    margin-left: 5%;
    text-align: center;


    @media (max-width: 992px) {
        top: 55%;
        font-size: 16px;
    }

    @media (max-width: 576px) {
        top: 65%;
        font-size: 14px;
}  
`

export const Middle = styled.div`
    position: absolute;
    top: 40%;
    text-align: center; 
    width: 90%;
    margin-left: 5%; 
`

export const Supported = styled.div`
    display:  ${props => props.display||'block'};
    font-size: 16px;
    

    @media (max-width: 992px) {
        font-size: 16px;
    }

    @media (max-width: 576px) {
        font-size: 14px;
}  
`

export const Error = styled.div`
    display:  ${props => props.display||'block'};
    color: red;
    font-size: 16px;
    width: 90%;
    margin-left: 5%;
    text-align: center;


    @media (max-width: 992px) {
        font-size: 16px;
    }

    @media (max-width: 576px) {
        font-size: 14px;
}  
`
export const Unsupported = styled.div`
    display:  ${props => props.display||'block'};
    color: #ffffff66;
    font-size: 16px;
    width: 90%;
    margin-left: 5%;

    @media (max-width: 992px) {
        font-size: 16px;
    }

    @media (max-width: 576px) {
        font-size: 14px;
}  
`

export const UserInformation = styled.div`
    display:  ${props => props.display||'block'};
    max-width: ${props => props.width+'px'||'100%'};
    z-index: 1;
    flex-wrap: wrap;
    line-height: 22px;
    position: absolute;
    flex-direction: row;
    top: 0;
    right: ${props => props.userString=== "Sign In" ? "10px" : "140px"||0};

    @media (max-width: 992px) {
        font-size: 16px;
    }

    @media (max-width: 576px) {
        top: 34px;
        flex-direction: column;
        right: ${props => props.userString=== "Sign In" ? "10px" : "10px"||0};    
}  
`

export const CompanySite = styled.select`
    border-style: none;
    white-space: inherit;
    border-style: none;
    line-height: 16px;
    font-size: 14px;
    max-width: ${props => props.width+'px'||'100%'};
    cursor: pointer;
    padding-right: 15px;
    background-color: #333333;
    background-image:
        linear-gradient(45deg, transparent 50%, white 50%),
        linear-gradient(135deg, white 50%, transparent 50%);
    background-position:
            calc(100% - 7px) calc(1em - 6px),
            calc(100% - 3px) calc(1em - 6px);
    background-size:
            5px 5px,
            5px 5px,
            1px 1.5em;
  
  background-repeat: no-repeat;
  -webkit-appearance: none;
  -moz-appearance: none;
`
export const TokenEnter = styled.i`
    color: ${props => props.disabled ? "#ffffff66" : "#ffffff"};
    cursor: ${props => props.disabled ? "not-allowed" : "pointer"};
    position: relative;
    top: 5px;
`

export const Header= styled.div`
    position: absolute;
    top: 10px;
    left: 10px;
    width: 180px;
    height: 180px;

@media (max-width: 992px) {
    width: 140px;
    height: 140px;
}

@media (max-width: 576px) {
    width: 100px;
    height: 100px;
}  
`


